// // The browser platform with a compiler
// import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

// // The app module
// import { AppModule } from './app.module';

// // Compile and launch the module
// platformBrowserDynamic().bootstrapModule(AppModule);
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { environment } from '../environments/environment';
import { AppModule } from './app.module';

if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.log(err));



// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/main.ts